export default __webpack_public_path__ + "static/media/folder-1.fa500965.png";